import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// this route is intentionality diferent to the res. with no new.js
import StatusNewView from 'Views/New/New';
// routes with index.js
import AllView from 'Views/All';
import PendingHrView from 'Views/PendingHr';
import PendingDesView from 'Views/PendingDes';
import PendingBttView from 'Views/PendingBtt';
import ConfirmedView from 'Views/Confirmed';
import DashboardView from 'Views/Dashboard';
import SettingsView from 'Views/Settings';

import TicketProfile from 'Views/TicketProfile/TicketProfile';
import { DS_F2W_Business_Travel_Team } from 'Constants/F2wRolesConstants';
import ProtectedRoute from './ProtectedRoute';

// Route elements extracted as constants outside the component (S6478)
const healthRedirect = <Navigate to="/new" replace />;
const rootRedirect = <Navigate to="/new" replace />;
const allElement = <AllView />;
const newElement = <StatusNewView />;
const pendingHrElement = <PendingHrView />;
const pendingBttElement = <PendingBttView />;
const pendingDesElement = <PendingDesView />;
const confirmedElement = <ConfirmedView />;
const dashboardElement = <DashboardView />;
const settingsElement = <ProtectedRoute element={<SettingsView />} allowedRoles={[DS_F2W_Business_Travel_Team]} />;
const ticketProfileElement = <TicketProfile />;

const TppSwitcher = () => {
  return (
    <Routes>
      <Route path="/health" element={healthRedirect} />
      <Route path="/" element={rootRedirect} />

      <Route path="/all" element={allElement} />
      <Route path="/new" element={newElement} />
      <Route path="/pendinghr" element={pendingHrElement} />
      <Route path="/pendingbtt" element={pendingBttElement} />
      <Route path="/pendingdes" element={pendingDesElement} />
      <Route path="/confirmed" element={confirmedElement} />
      <Route path="/dashboard" element={dashboardElement} />

      <Route path="/settings" element={settingsElement} />

      <Route path="/:status/:ticketId" element={ticketProfileElement} />
    </Routes>
  );
};

export default TppSwitcher;
